import React, { useEffect, useState } from "react";

import Axios, { CancelToken } from "axios";

import { IMeta } from "components/prime-data-table/interfaces";

interface IUseDualTableArgs {
    url: string | undefined;
    params?: any;
    urlParams?: string;
    excluded?: number[] | string[];
}

type TDualTableData<T> = IDualTableData<T> | IDualTableDataDeprecated<T>;
interface IUseDualTable<T, DataType extends TDualTableData<T>> {
    data: DataType | undefined;
    setData: React.Dispatch<React.SetStateAction<DataType | undefined>>;
    reloadData: (urlParams?: string, excluded?: number[], initial?: boolean, token?: CancelToken) => void;
}
export interface IDualTableData<T> {
    notSelected: {
        data: T[];
        meta: IMeta;
    };
    selected: T[];
}

export interface IDualTableDataDeprecated<T> {
    firstTable: {
        data: T[];
        meta: IMeta;
    };
    secondTable: T[];
}

export const useDualTable = <T, DataType extends TDualTableData<T> = IDualTableData<T>>({
    url,
    excluded = [],
    params,
    urlParams,
}: IUseDualTableArgs, dependecyArray: unknown[] = []): IUseDualTable<T, DataType> => {
    const [data, setData] = useState<DataType>();

    useEffect(() => {
        const source = Axios.CancelToken.source();
        
        getData(urlParams, excluded, true, source.token);

        return () => source.cancel();
    }, [...dependecyArray]);

    const getData = async (
        urlParams = "?pageSize=5&page=1",
        excluded: number[] | string[] = [],
        initial: boolean | undefined = undefined,
        token?: CancelToken
    ) => {
        if (!url) return;
        try {
            const response = await Axios.get(url + urlParams, {
                params: { excluded, initial, ...params },
                cancelToken: token,
            });

            setData(response.data);
        } catch (err: any) {
            console.error(err);
        }
    };
    return { data, setData, reloadData: getData };
};
